import React from 'react';
import { graphql } from 'gatsby';
import { OmRefinedDownloadCard } from '@om/component-library-react';

const RefinedDownloadCard = ({
    refinedDownloadCardContent,
    slot,
    isLandscape,
    isExtended,
}) => {

    if (!refinedDownloadCardContent) {
        return '';
    }

    const {
        uid,
        image_url_refined_download_card,
        image_text,
        image_alt,
        button_action_type,
        button_text,
        button_url,
        text_body_slot,
        open_tab,
        call_me_back,
    } = refinedDownloadCardContent;

    return (
        <OmRefinedDownloadCard
            id={uid}
            slot={slot}
            imageUrl={image_url_refined_download_card ? image_url_refined_download_card.url : ''}
            imageText={image_text ? image_text : ''}
            imageAlt={image_alt ? image_alt : ''}
            buttonText={button_text}
            buttonUrl={button_url ? button_url.href : ''}
            buttonActionType={button_action_type}
            callMeBackObject={call_me_back ? JSON.stringify(call_me_back) : ''}
            openTab={open_tab}
            isLanscape={isLandscape}
            isExtended={isExtended}
        >
            { text_body_slot ? <span slot="text-body-slot" dangerouslySetInnerHTML={{ __html: text_body_slot }} /> : ''}
        </OmRefinedDownloadCard>
    )
}

export const pageQuery = graphql`
     fragment RefinedDownloadCard on Contentstack_refined_download_card{
         uid,
         image_url_refined_download_card: image_url{
             ...File
         }
         image_text
         image_alt
         button_action_type
         button_text
         button_url{
             ...Link
         }
         text_body_slot
         open_tab
         call_me_back{
             ...CallMeBack
         }

     }
 `
export default RefinedDownloadCard;
